import Icon from '../../components/Icon.vue'

Icon.register({"regular/hdd":{"width":576,"height":512,"paths":[{"d":"M567.4 235.6L462.3 84.6A48-48 0 0 1 422.9 64H153.1A48-48 0 0 1 113.7 84.6L8.6 235.6A48-48 0 0 1 0 263.1V400C0 426.5 21.5 448 48 448H528C554.5 448 576 426.5 576 400V263.1C576 253.3 573 243.7 567.4 235.6zM153.1 112H422.9L500.8 224H75.2L153.1 112zM528 400H48V272H528V400zM496 336C496 353.7 481.7 368 464 368S432 353.7 432 336 446.3 304 464 304 496 318.3 496 336zM400 336C400 353.7 385.7 368 368 368S336 353.7 336 336 350.3 304 368 304 400 318.3 400 336z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/hdd.js
// module id = null
// module chunks = 